import React from "react";

export default function renderIf(condition) {
  return Component => props => {
    if (condition(props)) {
      return <Component {...props} />;
    }

    return false;
  };
}



// WEBPACK FOOTER //
// ./app/modules/shared/decorators/renderIf.jsx